import { GetRegistrationSiteResult, GetRegistrationSitesResult, RegisterResult, RegisterScenarioEnum } from '../api';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';

const MOCK_REGISTRATION_SITES_OK: GetRegistrationSitesResult = {
  registrationSites: [
    {
      allowSansCaisseRegistration: false,
      hasBadgeRegistration: false,
      hasCheckEmailRegistration: false,
      hasEmailRegistration: false,
      hasNomPrenomRegistration: false,
      hasSoldeRegistration: false,
      codePostal: '92400',
      siteName: 'TOUR EGEE',
      siteNameLong: 'TOUR EGEE sans étape 4',
      typeContratRequired: false,
    },
    {
      allowSansCaisseRegistration: false,
      hasBadgeRegistration: true,
      hasCheckEmailRegistration: false,
      hasEmailRegistration: true,
      hasNomPrenomRegistration: true,
      hasSoldeRegistration: false,
      codePostal: '92400',
      siteName: 'TOUR EGEE',
      siteNameLong: 'TOUR EGEE avec badge uniquement',
      typeContratRequired: false,
    },
    {
      allowSansCaisseRegistration: false,
      hasBadgeRegistration: false,
      hasCheckEmailRegistration: false,
      hasEmailRegistration: true,
      hasNomPrenomRegistration: true,
      hasSoldeRegistration: true,
      codePostal: '92400',
      siteName: 'TOUR EGEE',
      siteNameLong: 'TOUR EGEE avec solde uniquement',
      typeContratRequired: false,
    },
    {
      allowSansCaisseRegistration: true,
      hasBadgeRegistration: true,
      hasCheckEmailRegistration: false,
      hasEmailRegistration: true,
      hasNomPrenomRegistration: true,
      hasSoldeRegistration: true,
      codePostal: '92400',
      siteName: 'TOUR EGEE',
      siteNameLong: 'TOUR EGEE avec badge optionnel',
      typeContratRequired: false,
    },
    {
      allowSansCaisseRegistration: true,
      hasBadgeRegistration: true,
      hasCheckEmailRegistration: false,
      hasEmailRegistration: true,
      hasNomPrenomRegistration: true,
      hasSoldeRegistration: true,
      codePostal: '92400',
      siteName: 'TOUR EGEE',
      siteNameLong: 'TOUR EGEE complet',
      typeContratRequired: true,
    },
  ],
};

export const MOCK_REGISTRATION_SITES = {
  OK: MOCK_REGISTRATION_SITES_OK,
};

const MOCK_REGISTRATION_SITE_OK: GetRegistrationSiteResult = {
  registrationSite: MOCK_REGISTRATION_SITES_OK.registrationSites[2],
};

export const MOCK_REGISTRATION_SITE = {
  OK: MOCK_REGISTRATION_SITE_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

const MOCK_REGISTER_OK: RegisterResult = {
  scenario: RegisterScenarioEnum.Ok,
  authToken: { accessToken: 'accessToken', accessTokenExpirationDate: new Date(2025, 1, 1).toISOString(), refreshToken: 'refreshToken' },
};

const MOCK_REGISTER_OK_BUT_REQUIRES_EMAIL_VALIDATION: RegisterResult = {
  scenario: RegisterScenarioEnum.OkButRequiresEmailValidation,
};

const MOCK_REGISTER_AMBIGOUS_ACCOUNTS: RegisterResult = {
  scenario: RegisterScenarioEnum.AmbigousAccounts,
  ambigousAccounts: [
    { firstName: 'Philippe', lastName: 'Durant', badgeNumber: 'badge number 1' },
    { firstName: 'Philippe', lastName: 'Durand', badgeNumber: 'badge number 2' },
    { firstName: 'Philippe', lastName: 'Dupont', badgeNumber: 'badge number 3' },
    { firstName: 'Daniel', lastName: 'Durand', badgeNumber: 'badge number 4' },
    { firstName: 'Compte', lastName: 'Durand ', badgeNumber: 'badge number 5' },
    { firstName: 'Philipe', lastName: 'Durand ', badgeNumber: 'badge number 6' },
  ],
};

export const MOCK_REGISTER = {
  OK: MOCK_REGISTER_OK,
  AMBIGOUS_ACCOUNTS: MOCK_REGISTER_AMBIGOUS_ACCOUNTS,
  EMAIL_VALIDATION: MOCK_REGISTER_OK_BUT_REQUIRES_EMAIL_VALIDATION,
};

export const MOCK_REGISTRATION_ENSURE_EMAIL_VALIDITY = {
  OK: true,
};

export const MOCK_CONFIRM_EMAIL_SENT = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_EMAIL_CONFIRMED = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const UNREGISTER = {
  OK: true,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
